import type React from 'react';

export interface DownloadIconProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	stroke?: string;
	'aria-label'?: string;
}

const DownloadIcon: React.FC<DownloadIconProps> = ({
	width = 13,
	height = 17,
	fill = 'currentColor',
	stroke = 'currentColor',
	'aria-label': ariaLabel = 'Download',
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 13 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-label={ariaLabel}
		>
			<title>Download Icon</title>
			<path
				d="M1.91936 8.64493L6.51617 13.2417L1.91936 8.64493ZM6.51617 13.2417L11.113 8.64493L6.51617 13.2417ZM6.51617 13.2417V1.29004V13.2417ZM1 15.9998H12.0323H1Z"
				fill={fill}
			/>
			<path
				d="M1.91936 8.64493L6.51617 13.2417M6.51617 13.2417L11.113 8.64493M6.51617 13.2417V1.29004M1 15.9998H12.0323"
				stroke={stroke}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default DownloadIcon;
